import cx from 'classnames';

import styles from './InputFieldWrapper.module.scss';

type InputFieldWrapperProps = {
  children: React.ReactNode;
  customClassName?: string;
  hasDefaultStyles?: boolean;
};

export const InputFieldWrapper = ({ children, customClassName, hasDefaultStyles = true }: InputFieldWrapperProps) => (
  <div className={cx({
    [styles.inputField]: hasDefaultStyles,
    [`${customClassName}`]: !!customClassName,
  })}>
    {children}
  </div>
);
